import * as _ from 'lodash';

export const setUnreadCommentsCount = (rightPanelNavs: Array<any>, unreadCount: number): void => {
  const comments = _.find(rightPanelNavs, ['name', 'comments']);
  if (!comments) { return; }
  if (unreadCount) {
    comments.badge = true;
    comments.badgeTitle = unreadCount;
  } else {
    comments.badge = false;
    comments.badgeTitle = null;
  }
};
